import { Columns } from './columns';
import { Hero } from './hero';
import { HeroSecondary } from './heroSecondary';
import { Testimonial } from './testimonial';
import { ImageText } from './imageText';
import { BioCollection } from './bioCollection';
import { Header } from './header';
import { Brands } from './brands';
import { Footer } from './footer';
import { Action } from './action';
import { ProjectCollection } from './projectCollection';
import { BlogPostCollection } from './blogPostCollection';
import { TestimonialCollection } from './testimonialCollection';
import { Flyin } from './flyin';
import { Form } from './form';
import { HeroCentered } from './heroCentered';
import { FullWidthQuote } from './fullWidthQuote';
import { TechPartnerCollection } from './techPartnerCollection';
import { TechPartner } from './techPartner';
import {FullWidthBlurb} from './fullWidthBlurb';
import {ImageTextCollection} from './imageTextCollection';
import {SectionWithMarquee} from './sectionWithMarquee';
import {Collage} from './collage';
import {ImageTextAlternative} from './imageTextAlternative';

export const components: { [index: string]: any } = {
  header: Header,
  columns: Columns,
  collage: Collage,
  hero: Hero,
  heroSecondary: HeroSecondary,
  technologyPartner: TechPartner,
  testimonial: Testimonial,
  imageText: ImageText,
  imageTextCollection: ImageTextCollection,
  bioCollection: BioCollection,
  projectCollection: ProjectCollection,
  testimonialCollection: TestimonialCollection,
  fullWidthQuote: FullWidthQuote,
  fullWidthBlurb: FullWidthBlurb,
  imageTextAlternative: ImageTextAlternative,
  sectionWithMarquee: SectionWithMarquee,
  flyin: Flyin,
  blogPostCollection: BlogPostCollection,
  brands: Brands,
  footer: Footer,
  action: Action,
  form: Form,
  heroCentered: HeroCentered,
  techPartnerCollection: TechPartnerCollection,
  default: null,
};
